import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import preLoaderActions from 'actions/preLoaderActions';
import productsActions from 'actions/productsActions';
import { actions as formActions } from 'react-redux-form';
import InitialViewComponent from './InitialView';
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';

const mapStateToProps = state => {
    return {
        userProfile: state.userProfile,
        hireSolidarityCard: state.hireSolidarityCard,
        partner: state.products.get('partner'),
    };
};

const mapDispatchToProps = dispatch => ({
    preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    productsActions: bindActionCreators(productsActions, dispatch),
    formActions: bindActionCreators(formActions, dispatch),
});

export const InitialView = connect(mapStateToProps, mapDispatchToProps)(withFeatureToggling(InitialViewComponent));
